import React, { useEffect, useState } from 'react';
import { FaListAlt } from 'react-icons/fa';
import * as Motion from 'motion/react';
import DashboardList, { DashboardSessionListRenderComponent } from '../../components/DashboardList';
import Loader from '../../components/Loaders';
import { getSessions } from '../../api/v1/sessions';
import { animationStaggeredItem } from '../../animations';
import '../../styles/screen.scss';

const { motion } = Motion;


const Sessions = () => {
  const [sessions, setSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadSessionList = async () => {
    const result = await getSessions();

    setSessions(result?.data);
  };

  useEffect(() => {
    (async () => {
      await loadSessionList();
      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      <Motion.AnimatePresence>
        {isLoading && <Loader/>}
      </Motion.AnimatePresence>

      <motion.div variants={animationStaggeredItem} className="screen-header">
        <div className="screen-title-wrapper">
          <h2 className="screen-title">
            <FaListAlt/>
            Sessions
          </h2>
        </div>
      </motion.div>

      <DashboardList items={sessions} RenderComponent={DashboardSessionListRenderComponent}/>
    </>
  )
};

export default Sessions;
